var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuizCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 475,
    height: 461,
    viewBox: "0 0 475 461",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_80_1121)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M475 461H0V0H475V461ZM274.064 9.0957C232.046 6.43849 86.9752 6.8702 50.9355 30.918C8.41091 59.3169 14.9302 81.3055 13.1738 152.253C11.3161 225.758 11.0459 258.143 6.79004 323.277C4.22301 362.704 3.91862 432.357 71.8096 447.968C115.517 457.932 300.309 450.957 371.611 445.377C434.301 440.461 453.858 396.75 463.315 356.028C470.105 326.733 465.781 214.564 463.957 191.147C459.634 137.572 467.537 82.9001 432.24 40.252C399.68 0.858779 322.534 12.2844 274.064 9.0957Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_80_1121"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 475,
    height: 461,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuizCard);
export default __webpack_public_path__ + "static/media/quiz-card.7087cbd8ad058e2938640edd747f5c11.svg";
export { ForwardRef as ReactComponent };